import { AppRoutes } from '../../Core/App/AppRoutes';
import { AppRouteType } from '../Components/Templates/AppRouter/AppRouteType';
import { getAffaireRoutes } from './Routes/AffaireRoutes';
import { getAuthRoutes } from './Routes/AuthRoutes';
import { getCauserieRoutes } from './Routes/CauserieRoutes';
import { getClientRoutes } from './Routes/ClientRoutes';
import { getCompagnonRoutes } from './Routes/CompagnonRoutes';
import { getControleRoutes } from './Routes/ControleRoutes';
import { getEnginRoutes } from './Routes/EnginRoutes';
import { getMaterielRoutes } from './Routes/MaterielRoutes';
import { getMessageRoutes } from './Routes/MessageRoutes';
import { getPlanningRoutes } from './Routes/PlanningRoutes';
import { getPointageRoutes } from './Routes/PointageRoutes';
import { getRHRoutes } from './Routes/RHRoutes';
import { getVehiculeRoutes } from './Routes/VehiculeRoutes';

const DEFAULT_ROUTE = AppRoutes.HOME;

const getAppRoutes = (): AppRouteType[] => [
    ...getAuthRoutes({}),
    ...getControleRoutes({}),
    ...getPointageRoutes({}),
    ...getAffaireRoutes({}),
    ...getCauserieRoutes({}),
    ...getMessageRoutes({}),
    ...getRHRoutes({}),
    ...getCompagnonRoutes({}),
    ...getEnginRoutes({}),
    ...getMaterielRoutes({}),
    ...getClientRoutes({}),
    ...getVehiculeRoutes({}),
    ...getPlanningRoutes({}),
];

export { getAppRoutes, DEFAULT_ROUTE };
